import * as React from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import DotsIcon from '@components/basics/icons/dots';
import CloseIcon from '@components/basics/icons/close';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import CircleArrowIcon from '@components/basics/icons/circle-arrow';

interface MenuDropdownHeaderProps {
  className?: string;
  label?: React.ReactNode;
  placeholder?: React.ReactNode;
  onClick: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isOpen: boolean;
  hasDottedIcon?: boolean;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const MenuDropdownHeader: React.FC<MenuDropdownHeaderProps> = (
  props
) => {
  return (
    <Flex
      className={props.className}
      alignItems="center"
      onClick={props.onClick}
    >
      {props.placeholder || props.label ? (
        <div className="text">
          {props.placeholder ? (
            <Typography className="placeholder" weight="700" opacity=".5">
              {props.placeholder}
            </Typography>
          ) : null}
          {props.label ? (
            <Typography
              className="label"
              type={props.isMobile ? 'analytics-nav' : ''}
              weight={props.isMobile ? '400' : '700'}
            >
              {props.label}
            </Typography>
          ) : null}
        </div>
      ) : null}
      {!props.hasDottedIcon ? (
        <CircleArrowIcon
          className="icon-arrow"
          arrowUp={props.isOpen}
          size={props.isMobile ? '40px' : '24px'}
        />
      ) : !props.isOpen ? (
        <DotsIcon noBg />
      ) : (
        <CloseIcon noHover noBg />
      )}
    </Flex>
  );
};

export default connect(mapStateToProps)(styled(MenuDropdownHeader)`
  justify-content: space-between;

  @media ${({ theme }) => theme.device.tablet} {
    justify-content: flex-end;
  }

  .label {
    @media ${({ theme }) => theme.device.tablet} {
      margin-right: 12px;
    }
  }

  .placeholder {
    margin-bottom: 5px;
  }

  .label,
  .icon-arrow {
    cursor: pointer;
  }
`);
